import React, { Dispatch, SetStateAction, useState, useEffect } from 'react'

import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    IconButton,
    InputLabel,
    Select,
    MenuItem,
    styled,
    CircularProgress


} from '@mui/material';

import ProcessMapUploadForm from '../../Forms/ProcessMapUploadForm/ProcessMapUploadForm';
import { X } from 'lucide-react';
import { apiService } from '../../../../api/apiService';
import { Label } from '@mui/icons-material';
import useFunctionOptions from '../../utils/useFunctionOptions';
import SuccessPopup from '../../Popup/Success&ErrorPopup/SuccessPopup';
import ErrorPopup from '../../Popup/Success&ErrorPopup/ErrorPopup';
import { useMsal } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';



interface ProcessFile {
    id: string;
    name: string;
    date: string;
    functionL1: string;

    status: string;
    size: string;
}

interface RecruitmentSelectionSectionPopupProps {
    openUpload: boolean;
    setOpenUpload: Dispatch<SetStateAction<boolean>>;
    management: string;
    verticalTabValue?: string;
    onSuccess?: () => void;


}

const StyledMenuItem = styled(MenuItem)({
    color: 'black', // Set the text color to black
    '&:hover': {
        backgroundColor: '#f0f0f0', // Optional: hover background color
    },
});



const RecruitmentSelectionSectionPopup: React.FC<RecruitmentSelectionSectionPopupProps> = ({ openUpload, setOpenUpload, management, verticalTabValue, onSuccess }) => {
    const { instance } = useMsal();

    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [files, setFiles] = useState<ProcessFile[]>([]);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [uploading, setUploading] = useState<boolean>(false);

    const [functionL1, setFunctionL1] = useState('');
    const [functionL2, setFunctionL2] = useState('');
    
    // const management = localStorage.getItem('management') || '';


    const { options: l1Options, loading: l1Loading } = useFunctionOptions('l1', '');
    const { options: l2Options, loading: l2Loading } = useFunctionOptions('l2', functionL1);


    console.log('management:', management);

    const handleFileSelect = (file: File) => {
        setSelectedFile(file);
    };

    const currentYear = new Date().getFullYear();
    const years = Array.from(new Array(10), (val, index) => currentYear - 1 + index);
    const handleSubmit = async () => {

        if (selectedFile) {
            // Create a FormData instance
            const formData = new FormData();

            // Create the process_map_req object
            const processMapReq = {
                // manager_id: "some_manager_id", 
                section_name: verticalTabValue,
                function_l1: functionL1,
                function_l2:functionL2,
                management: management, // Replace with actual data

                // month: functionL2,
                // year: functionL3,
            };

            // Append the process_map_req object as a JSON string
            formData.append("recruitment_n_Selection", JSON.stringify(processMapReq));
            formData.append("file", selectedFile); // Append the file as binary data

            console.log("Payload:", Array.from(formData.entries()));
            setUploading(true);

            try {
                const response = await apiService("/people/recruitment_n_selection", "POST", formData, undefined, instance as PublicClientApplication);

                if (response.error) {
                    console.error("Error submitting process map:", response.error);
                    return;
                }

                console.log("Submission successful:", response);

                setFiles([
                    {
                        id: Math.random().toString(36).substr(2, 9),
                        name: selectedFile.name,
                        date: new Date().toLocaleDateString(),
                        functionL1,

                        status: "Submitted",
                        size: `${Math.round(selectedFile.size / 1024)} KB`,
                    },
                    ...files,
                ]);

                setOpenUpload(false);
                resetUploadState();
                setShowSuccess(true);
                if (onSuccess) {
                    onSuccess(); // Call the callback function after successful upload
                }
            } catch (error) {
                console.error("Error during submission:", error);
                setErrorMessage("An error occurred during submission. Please try again.");
                setShowError(true);
            } finally {
                setUploading(false);
            }

        }
    };
    const resetUploadState = () => {
        setSelectedFile(null);
        setFunctionL1('');

    };



    useEffect(() => {
        let timer: NodeJS.Timeout;
        if (showSuccess) {
            timer = setTimeout(() => {
                setShowSuccess(false);
            }, 3000);
        }
        return () => clearTimeout(timer);
    }, [showSuccess]);

    useEffect(() => {
        let timer: NodeJS.Timeout;
        if (showError) {
            timer = setTimeout(() => {
                setShowError(false);
            }, 3000);
        }
        return () => clearTimeout(timer);
    }, [showError]);


    return (
        <>
            <Dialog
                open={openUpload}
                onClose={() => {
                    setOpenUpload(false);
                    resetUploadState();
                }}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: '#000', fontFamily: "Avant semibold", fontWeight: "600" }}>
                    {verticalTabValue}
                    <IconButton onClick={() => setOpenUpload(false)}>
                        <X size={24} />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ mt: 2 }}>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel>Function L1 *</InputLabel>
                            <Select
                                sx={{ borderRadius: '8px', color: '#000' }}
                                value={functionL1}
                                label="Function L1 *"
                                onChange={(e) => setFunctionL1(e.target.value)}
                            >
                                <StyledMenuItem value="">Select Function L1</StyledMenuItem>
                                {l1Loading ? (
                                    <StyledMenuItem value="">
                                        <CircularProgress size={24} />
                                    </StyledMenuItem>
                                ) : (
                                    l1Options.map((option, index) => (
                                        <StyledMenuItem key={index} value={option}>
                                            {option}
                                        </StyledMenuItem>
                                    ))
                                )}
                            </Select>
                        </FormControl>

                       {/* Function L2 */}
                            <FormControl fullWidth sx={{ mb: 2 }}>
                              <InputLabel>Function L2 *</InputLabel>
                              <Select
                                sx={{ borderRadius: '8px', color: '#000' }}
                                value={functionL2}
                                label="Function L2 *"
                                onChange={(e) => setFunctionL2(e.target.value)}
                                disabled={!functionL1}
                              >
                                <StyledMenuItem value="">Select Function L2</StyledMenuItem>
                                {l2Loading ? (
                                  <StyledMenuItem value="">
                                    <CircularProgress size={24} />
                                  </StyledMenuItem>
                                ) : (
                                  l2Options.map((option, index) => (
                                    <StyledMenuItem key={index} value={option}>
                                      {option}
                                    </StyledMenuItem>
                                  ))
                                )}
                              </Select>
                            </FormControl>



                    </Box>
                    <ProcessMapUploadForm
                        file={selectedFile}
                        onFileSelect={handleFileSelect}
                        fileTitle="Job descriptions for all unique role across bands should be properly applied and updated. Track completion rates for JD reviews and conduct audits to ensure JDs are up-to-date and accurately aligned with responsibilities."
                        onFileRemove={() => {
                            setSelectedFile(null);
                        }}
                    />
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                    <Button variant='outlined' onClick={() => setOpenUpload(false)} sx={{ color: '#000', borderColor: '#000' }}>Cancel</Button>
                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        disabled={!selectedFile || uploading}
                        sx={{
                            color: 'white',
                            bgcolor: 'black',
                            '&:hover': { bgcolor: 'black' },
                            '&:disabled': { bgcolor: 'grey.300' },
                        }}
                    >
                        {uploading ? "Uploading..." : "Submit"}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Success Popup */}
            <SuccessPopup
                open={showSuccess}
                onClose={() => setShowSuccess(false)}
                message="GBS Process under BCP uploaded successfully!"
            />

            {/* Error Popup */}
            <ErrorPopup
                open={showError}
                onClose={() => setShowError(false)}
                message={errorMessage}
            />
        </>
    )
}

export default RecruitmentSelectionSectionPopup